import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";

function PaymentType() {

  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  return (<>
    <div className="div__group__input_select mx-2">
      <label className="" htmlFor={"rnd1"}>
        نوع پرداخت
      </label>
      <select
        className="form__select__div__group__input_select"
        value={data.paymentType}
        onChange={e => {
          setData({paymentType: e.target.value})
        }}>
        <option value="online">آنلاین</option>
        <option value="inPlace">در محل</option>
        <option value="wallet">کیف پول</option>
      </select>
    </div>
  </>);
}

export default PaymentType;